import { render, staticRenderFns } from "./customerRD.vue?vue&type=template&id=18c28a0c&scoped=true&"
import script from "./customerRD.vue?vue&type=script&lang=js&"
export * from "./customerRD.vue?vue&type=script&lang=js&"
import style0 from "./customerRD.vue?vue&type=style&index=0&id=18c28a0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c28a0c",
  null
  
)

export default component.exports